<div class="scanner-container">
  <video #scannerVideo class="scanner-video" autoplay muted playsinline></video>
</div>
<div style="width: 100%; min-width: 300px; margin-bottom: 5px; text-align:center">
  @if (error) {
    <span class="scanner-error">⚠ {{ error }}</span>
  }
  @if (scanning && !error) {
    <span>Scanning...</span>
  }
  @if (!scanning) {
    <span>Barcode: {{ code }}</span>
  }
  <div style="width: 100%; margin-bottom: 20px;"></div>
  <button mat-raised-button color="primary" (click)="cancelScanning()" class="wk-flex-fix" style="float: left;">Cancel</button>
  <button mat-raised-button color="primary" (click)="close()" [disabled]="scanning" class="wk-flex-fix" style="float: right">Confirm</button>
</div>
